import React, { useState, useEffect } from "react";
import VisibilitySensor from "react-visibility-sensor";
import styles from "./index.module.scss";
import _ from "lodash";
import Grid from "@material-ui/core/Grid";
import * as icons from "../../config/Icons";
import { t } from "i18next";

export default function BarChartStackedComplience({
  titles,
  colors3,
  data,
  colors,
  fontColors,
  legends,
  colors2,
  fontColors2,
  legends2,
  avgcolors,
  labelX,
  labelY,
  showTotal,
  totalSuffix,
  animDuration = 1000,
  animPredelay = 0,
  country = false,
  ...props
}) {
  const [totals, setTotals] = useState([]);
  const [maxTotal, setMaxTotal] = useState([]);
  const [showValues, setShowValues] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setTimeout(() => {
        setShowValues(true);
      }, animPredelay);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVisible]);

  // only animate on component visibility
  const onVisibilityChange = isVisible => {
    if (isVisible) {
      setIsVisible(true);
    }
  };

  return (
    <>
      <Grid container>
        <Grid item xs={2}>
          <div className={styles.title} style={{ height: "23px" }}>
            <strong> </strong>
          </div>
          <li className={styles.barChartsHeaderScroll}>
            <div className={[styles.labelY, styles.show].join(" ")}>
              {labelX}
            </div>
          </li>
        </Grid>
        <Grid container xs={10}>
          <Grid item xs={4}>
            <div className={styles.title}>
              <strong>{titles[0]}</strong>
            </div>
            <li className={styles.barChartsHeaderScroll}>
              <div className={[styles.labelY, styles.show].join(" ")}>
                {labelY}
              </div>
            </li>
          </Grid>
          <Grid item xs={4}>
            <div className={styles.title}>
              <strong>{titles[1]}</strong>
            </div>
            <li className={styles.barChartsHeaderScroll}>
              <div className={[styles.labelY, styles.show].join(" ")}>
                {labelY}
              </div>
            </li>
          </Grid>
          <Grid item xs={4}>
            <div className={styles.title}>
              <strong>{titles[2]}</strong>
            </div>
            <li className={styles.barChartsHeaderScroll}>
              <div className={[styles.labelY, styles.show].join(" ")}>
                {titles[2] && titles[2] !== "" ? labelY : ""}
              </div>
            </li>
          </Grid>
        </Grid>
      </Grid>
      <VisibilitySensor onChange={onVisibilityChange}>
        <div className={styles.scrollBlock}>
          <Grid container>
            <Grid item xs={2} style={{ paddingTop: "0px" }}>
              <div className={styles.container}>
                <div className={styles.barCharts}>
                  {!_.isEmpty(data) && (
                    <ul className={styles.barChartsList}>
                      {data &&
                        data.complienceRateData.map((item, index) => {
                          const flagIcon =
                            country && item.label !== "average"
                              ? item.label + "FlagIcon"
                              : "";
                          return (
                            <li className={styles.barChartsItem} key={index}>
                              <div className={styles.labelX}>
                                {country && item.label !== "average" && (
                                  <img src={icons[flagIcon]} alt={item.label} />
                                )}
                                {item.label}
                              </div>
                            </li>
                          );
                        })}
                    </ul>
                  )}
                  {_.isEmpty(data) && (
                    <div className={styles.nodata}>
                      {t("dashboard.noDataYet")}
                    </div>
                  )}
                </div>
              </div>
            </Grid>

            <Grid xs={10} container>
              <Grid item xs={4}>
                <div className={styles.barCharts}>
                  {!_.isEmpty(data) && (
                    <ul className={styles.barChartsList}>
                      {data &&
                        data.incompleteRateData.map((item, index) => {
                          return (
                            <li className={styles.barChartsItem} key={index}>
                              <div className={[styles.labelY].join(" ")}>
                                <div
                                  style={{
                                    transition: `${animDuration}ms width`,
                                  }}
                                  className={[
                                    styles.labelYInner,
                                    showValues ? styles.show : "",
                                  ].join(" ")}
                                >
                                  <div
                                    className={styles.bar}
                                    style={{
                                      width: `${item.values}%`,
                                      backgroundColor: `  ${
                                        index === 0 ? avgcolors[0] : colors2[0]
                                      }`,
                                    }}
                                  ></div>
                                  <div className={styles.totalleft}>
                                    <strong>{`${item.values} % `}</strong>
                                  </div>
                                </div>
                              </div>
                              {/*                      
                        {showTotal && (
                          <div className={styles.total}>
                            <strong>{`${item.values} % `}</strong>
                          </div>
                        )} */}
                            </li>
                          );
                        })}
                    </ul>
                  )}
                  {_.isEmpty(data) && (
                    <div className={styles.nodata}>
                      {t("dashboard.noDataYet")}
                    </div>
                  )}
                </div>
                {/* <div className={styles.footer}>
              <div className={styles.legends}>
                <ul className={styles.legendsList}>
                  {legends2 && legends2.map((legend, index) => {
                    return (
                      <li className={styles.legendItem} key={index}>
                        <div
                          className={styles.legendColor}
                          style={{ backgroundColor: `${avgcolors[index]}` }}
                        ></div>
                        <div
                          className={styles.legendColor}
                          style={{ backgroundColor: `${colors2[index]}` }}
                        ></div>
                        <span>{legend}</span>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div> */}
              </Grid>
              <Grid item xs={4}>
                <div className={styles.barCharts}>
                  {!_.isEmpty(data) && (
                    <ul className={styles.barChartsList}>
                      {data &&
                        data.conditionalRateData.map((item, index) => {
                          return (
                            <li className={styles.barChartsItem} key={index}>
                              <div className={[styles.labelY].join(" ")}>
                                <div
                                  style={{
                                    transition: `${animDuration}ms width`,
                                  }}
                                  className={[
                                    styles.labelYInner,
                                    showValues ? styles.show : "",
                                  ].join(" ")}
                                >
                                  <div
                                    className={styles.bar}
                                    style={{
                                      width: `${item.values}%`,
                                      backgroundColor: `  ${
                                        index === 0 ? avgcolors[0] : colors3[0]
                                      }`,
                                    }}
                                  ></div>
                                  <div className={styles.totalleft}>
                                    <strong>{`${item.values} % `}</strong>
                                  </div>
                                </div>
                              </div>
                            </li>
                          );
                        })}
                    </ul>
                  )}
                  {_.isEmpty(data) && (
                    <div className={styles.nodata}>
                      {t("dashboard.noDataYet")}
                    </div>
                  )}
                </div>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </VisibilitySensor>
    </>
  );
}